import { render, staticRenderFns } from "./OrdiniMTM.vue?vue&type=template&id=4d8688f9&scoped=true"
import script from "./OrdiniMTM.vue?vue&type=script&lang=ts"
export * from "./OrdiniMTM.vue?vue&type=script&lang=ts"
import style0 from "./OrdiniMTM.vue?vue&type=style&index=0&id=4d8688f9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8688f9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d8688f9')) {
      api.createRecord('4d8688f9', component.options)
    } else {
      api.reload('4d8688f9', component.options)
    }
    module.hot.accept("./OrdiniMTM.vue?vue&type=template&id=4d8688f9&scoped=true", function () {
      api.rerender('4d8688f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OrdiniMTM.vue"
export default component.exports